import React, { useState, useEffect, useRef } from 'react';
import { MCard } from 'components/Shared';
import { userHasRight } from "selectors/rights";
import { connect } from "react-redux";
import { DATA_TYPE_DROPDOWN2 } from 'typeConstants/dataTypes';
import {
  getAuditPercentage, setAuditPercentage,
  getRejectionAuditPercentage, setRejectionAuditPercentage
} from 'requests/qaCaseAudit/index.ts';
import { QA_TEAM_MAINTENANCE } from 'typeConstants/rights';
import { MCardField } from 'components/Shared/MCard.tsx';

interface ITeamMemberManagementProps {
  internetUserId: number,
  canEditTeam: boolean,
  supervisorName: string,
}

const TeamMemberManagement = ({ internetUserId, canEditTeam, supervisorName = "N/A" }: ITeamMemberManagementProps) => {
  const [userAuditPercentage, setUserAuditPercentage] = useState(null);
  const [auditPercentageOptions, setAuditPercentageOptions] = useState([]);
  const [userRejectionAuditPercentage, setUserRejectionAuditPercentage] = useState(null);  
  const [rejectionAuditPercentageOptions, setRejectionAuditPercentageOptions] = useState([]);
  const mounted = useRef(true);

  useEffect(() => {

    getAuditPercentage(internetUserId, resp => {
      setUserAuditPercentage({
        label: `${resp.auditPercentage} %`,
        value: resp.auditPercentage
      });
      setAuditPercentageOptions(resp.auditPercentageOptions.map(t => ({
        label: `${t} %`,
        value: t
      })));
    }, null, mounted);

    getRejectionAuditPercentage(internetUserId, resp => {
      setUserRejectionAuditPercentage({
        label: `${resp.rejectionAuditPercentage} %`,
        value: resp.rejectionAuditPercentage
      });
      setRejectionAuditPercentageOptions(resp.rejectionAuditPercentageOptions.map(t => ({
        label: `${t} %`,
        value: t
      })));
    }, null, mounted);    

    return () => {
      mounted.current = false;
    };
  }, []);

  const fields: MCardField[] = [
    {
      key: "supervisor",
      label: "Supervisor",
      value: supervisorName,
      editable: false,
    },
    {
      key: "audit_percentage",
      label: "% of Cases to Audit",
      value: userAuditPercentage,
      dataType: DATA_TYPE_DROPDOWN2,
      editable: true,
      dataTypeOptions: { options: auditPercentageOptions, nullable: false }
    },
    {
      key: "rejection_audit_percentage",
      label: "% of Rejected Cases to Audit",
      value: userRejectionAuditPercentage,
      dataType: DATA_TYPE_DROPDOWN2,
      editable: true,
      dataTypeOptions: { options: rejectionAuditPercentageOptions, nullable: false }
    },    
  ];

  const handleSave = (arr, obj) => {
    if (Object.keys(obj).includes("audit_percentage")) {
      setAuditPercentage(internetUserId, obj.audit_percentage, resp => {
        setUserAuditPercentage({
          label: `${resp.auditPercentage} %`,
          value: resp.auditPercentage
        });
        setAuditPercentageOptions(resp.auditPercentageOptions.map(t => ({
          label: `${t} %`,
          value: t
        })));
      }, null, mounted);
    }
    if (Object.keys(obj).includes("rejection_audit_percentage")) {
      setRejectionAuditPercentage(internetUserId, obj.rejection_audit_percentage, resp => {
        setUserRejectionAuditPercentage({
          label: `${resp.rejectionAuditPercentage} %`,
          value: resp.rejectionAuditPercentage
        });
        setRejectionAuditPercentageOptions(resp.rejectionAuditPercentageOptions.map(t => ({
          label: `${t} %`,
          value: t
        })));
      }, null, mounted);
    }    
  };

  return (
    <MCard
      title="Designation"
      fields={fields}
      isEditable={canEditTeam}
      onEditFinished={handleSave}
    />
  );
};

const mapStateToProps = state => {
  return {
    canEditTeam: userHasRight(QA_TEAM_MAINTENANCE)(state),
  };
};

export default connect(mapStateToProps)(TeamMemberManagement);
